import { EventResponseDto } from '@diritto/common/event/dtos/event.dto';
import { Color } from '@diritto/common/style/color';
import { Typography } from '@diritto/common/style/typography';
import styled from '@emotion/styled';
import { EventHeader } from 'app-components/events/detail/EventHeader';
import { EventInfoContent } from 'app-components/events/detail/EventInfoContent';
import { EventShare } from 'app-components/events/detail/EventShare';
import { EventUsage } from 'app-components/events/detail/EventUsage';
import { EventBodyContainer } from 'ui-components/layout/containers/EventBodyContainer';
import { EventRaffleType } from '@diritto/common/event/constants';
import { EventRewardRaffle } from 'app-components/events/detail/rewards/EventRewardRaffle';
import { EventRewardNewContentPromote } from 'app-components/events/detail/rewards/EventRewardNewContentPromote';
import { SentryService } from 'utils/SentryService';

interface EventViewProps {
  eventData: EventResponseDto;
}

export const EventNewContentPromoteView = ({ eventData }: EventViewProps) => {
  const { event, contents, profiles, couponCatalog } = eventData;
  const { title, type, description, subDescription, extraInfo, raffleType } = event;

  if (!couponCatalog) {
    SentryService.captureMessage(`EventNewContentPromoteView: couponCatalog is null  eventId: ${event.id}`);
    return null;
  }

  return (
    <>
      <StyledEventHeader event={event}>
        <EventInfoContent type={type} info={extraInfo} contents={contents} profiles={profiles} />
      </StyledEventHeader>
      <EventBodyContainer>
        <StyledContainerWrapper>
          <StylesDescriptionWrapper>
            <StylesDescription>{description}</StylesDescription>
            {subDescription && <StylesSubDescription>{subDescription}</StylesSubDescription>}
          </StylesDescriptionWrapper>
          {raffleType === EventRaffleType.Reply ? (
            <EventRewardRaffle couponCatalog={couponCatalog} event={event} />
          ) : (
            <EventRewardNewContentPromote couponCatalog={couponCatalog} event={event} />
          )}
          <StyledDivider />
          <EventUsage couponRewardType={couponCatalog.rewardType} />
          <StyledDivider />
          <EventShare eventTitle={title} />
        </StyledContainerWrapper>
      </EventBodyContainer>
    </>
  );
};

const StyledEventHeader = styled(EventHeader)`
  padding-top: 24px;
  margin-bottom: 24px;
`;

const StyledContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  margin-bottom: 24px;
`;

const StylesDescriptionWrapper = styled.section`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StylesDescription = styled.p`
  ${Typography.XSmall}
  white-space: break-spaces;
`;

const StylesSubDescription = styled.div`
  ${Typography.XXSmall}
  color: ${Color.Gray600};
  margin-top: 16px;
  white-space: break-spaces;
`;

const StyledDivider = styled.div`
  margin: 48px auto;
  width: 120px;
  height: 1px;
  background-color: ${Color.Gray300};
  display: inline-block;
`;
